import React from 'react';
import styled from 'styled-components';
import { borderRadius, ErrorOutlineIcon, units } from '@m/alchemy-ui';

export interface ErrorFallbackProps {
  error: {
    message: string;
  };
  resetErrorBoundary: () => void;
}

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const ErrorBody = styled.section`
  margin-top: 20%;
  text-align: center;
`;

const StyledIcon = styled(ErrorOutlineIcon)`
  height: ${units(12)};
  width: ${units(12)};
  opacity: 0.2;
`;

const Title = styled.h1`
  font: bold ${units(2.5)} 'Nunito', sans-serif;
`;

const StyledButton = styled.button`
  display: inline-block;
  border: 0;
  padding: ${units(1)} ${units(2)};
  border-radius: ${borderRadius('extraLarge')};
  background: #4050c6;
  color: #fff;
  cursor: pointer;
  font: ${units(2)} 'Nunito', sans-serif;
`;

const strings = {
  errorMessage: 'Crowdicity has encountered an error.',
  tryAgain: 'Try again'
};

export const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => (
  <ErrorContainer>
    <ErrorBody role="alert">
      <StyledIcon />
      <Title>{strings.errorMessage}</Title>
      <StyledButton type="button" onClick={resetErrorBoundary}>
        {strings.tryAgain}
      </StyledButton>
    </ErrorBody>
  </ErrorContainer>
);
